module.exports = __webpack_public_path__ + "img/plus-add.5ae90adf.svg";